import React, { useEffect, useState } from "react";
import "./Whatsapp.css";
import CargandoSpinner from "../../0. Utilidades/loadingSpinner";
import { useNavigate } from "react-router-dom";
import {
  GiHammerNails,
  GiCircularSaw,
  GiToolbox,
  GiLadder,
  GiPaintBrush,
  GiDrill,
} from "react-icons/gi";
import { LuShovel } from "react-icons/lu";
import { FaWrench, FaRegLightbulb } from "react-icons/fa";

const VISIBLE_MAESTRAS = 7;

const WhatsappCarousel3D = () => {
  const [grupos, setGrupos] = useState([]);
  const [angle, setAngle] = useState(0);
  const [loading, setLoading] = useState(true);
  const [visibleStart, setVisibleStart] = useState({});
  const radius = 450;
  const navigate = useNavigate();

  useEffect(() => {
    const fetchGrupos = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_API}api/perfiles/whatsapp_grupos/`,
        );
        const data = await response.json();
        setGrupos(data);
      } catch (error) {
        console.error("Error fetching grupos:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchGrupos();
  }, []);

  const rotateLeft = () => setAngle((prev) => prev + 360 / grupos.length);
  const rotateRight = () => setAngle((prev) => prev - 360 / grupos.length);

  const handleGroupSelect = (event) => {
    const selectedIndex = parseInt(event.target.value);
    const anglePerGroup = 360 / grupos.length;
    setAngle(-anglePerGroup * selectedIndex);
  };

  const getRelacionClass = (e_relacion) => {
    switch ((e_relacion || "").toLowerCase()) {
      case "ok":
        return "bg-ok";
      case "supervision":
        return "bg-supervision";
      case "problema":
        return "bg-problema";
      default:
        return "bg-default";
    }
  };

  const iconPool = [
    <GiHammerNails />,
    <FaRegLightbulb />,
    <GiCircularSaw />,
    <GiToolbox />,
    <GiLadder />,
    <FaWrench />,
    <GiPaintBrush />,
    <LuShovel />,
    <GiDrill />,
  ];

  return (
    <div id="whatsapp">
      <h3>Grupos de WhatsApp</h3>
      {loading ? (
        <CargandoSpinner />
      ) : (
        <>
          <select className="group-selector" onChange={handleGroupSelect}>
            <option value="">Ir al grupo...</option>
            {grupos.map((grupo, index) => (
              <option key={index} value={index}>
                {grupo.nombre}
              </option>
            ))}
          </select>

          <div className="carousel-wrapper">
            <button onClick={rotateLeft}>&larr;</button>
            <div className="carousel-controls">
              <div className="carousel-scene">
                <div
                  className="carousel-ring"
                  style={{
                    transform: `translateZ(-${radius}px) rotateY(${angle}deg)`,
                  }}
                >
                  {grupos.map((grupo, i) => {
                    const theta = (360 / grupos.length) * i;
                    const start = visibleStart[grupo.id] || 0;
                    const currentMaestras = grupo.maestras.slice(
                      start,
                      start + VISIBLE_MAESTRAS,
                    );
                    const countByStatus = (status) =>
                      grupo.maestras.filter(
                        (m) => (m.e_relacion || "").toLowerCase() === status,
                      ).length;

                    const okCount = countByStatus("ok");
                    const supervisionCount = countByStatus("supervision");
                    const problemaCount = countByStatus("problema");

                    const handleScrollUp = () => {
                      setVisibleStart((prev) => ({
                        ...prev,
                        [grupo.id]: Math.max(0, start - VISIBLE_MAESTRAS),
                      }));
                    };

                    const handleScrollDown = () => {
                      setVisibleStart((prev) => ({
                        ...prev,
                        [grupo.id]: Math.min(
                          grupo.maestras.length - VISIBLE_MAESTRAS,
                          start + VISIBLE_MAESTRAS,
                        ),
                      }));
                    };

                    return (
                      <div
                        key={grupo.id || i}
                        className="carousel-card"
                        style={{
                          transform: `rotateY(${theta}deg) translateZ(${radius}px)`,
                        }}
                      >
                        <h3>{grupo.nombre}</h3>
                        <p className="whatsapp-actualizado">
                          Actualizado:{" "}
                          {new Date(grupo.actualizado).toLocaleDateString(
                            "es-CL",
                            {
                              day: "2-digit",
                              month: "short",
                              year: "numeric",
                            },
                          )}{" "}
                          {new Date(grupo.actualizado).toLocaleTimeString(
                            "es-CL",
                            {
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: false,
                            },
                          )}
                        </p>
                        <div className="status-counts">
                          <div className="status-box bg-ok">{okCount}</div>
                          <div className="status-box bg-supervision">
                            {supervisionCount}
                          </div>
                          <div className="status-box bg-problema">
                            {problemaCount}
                          </div>
                        </div>

                        <div className="maestra-list-container">
                          <button
                            className="scroll-btn"
                            onClick={handleScrollUp}
                            disabled={start === 0}
                            style={{ width: "100%" }}
                          >
                            ↑
                          </button>

                          <ul>
                            {currentMaestras.map((maestra, idx) => (
                              <li
                                key={idx}
                                className={`maestra-item ${getRelacionClass(
                                  maestra.e_relacion,
                                )}`}
                                onClick={() =>
                                  navigate(`/todas/${maestra.rut}`)
                                }
                              >
                                <span>{`${start + idx + 1}. ${
                                  maestra.nombre
                                }`}</span>
                                <div className="maestra-avatar">
                                  {iconPool[(start + idx) % iconPool.length]}
                                </div>
                              </li>
                            ))}
                          </ul>

                          <button
                            className="scroll-btn"
                            onClick={handleScrollDown}
                            disabled={
                              start + VISIBLE_MAESTRAS >= grupo.maestras.length
                            }
                            style={{ width: "100%" }}
                          >
                            ↓
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            <button onClick={rotateRight}>&rarr;</button>
          </div>
        </>
      )}
    </div>
  );
};

export default WhatsappCarousel3D;
